import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedicalExamYes = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "medicalExam-yes",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17535",
		"data-name": "Group 17535",
		transform: "translate(2 2.027)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12998",
				"data-name": "Path 12998",
				d: "M16.1,6.853,13.33,4.08",
				transform: "translate(-10.99 -3.387)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12999",
				"data-name": "Path 12999",
				d: "M15.86,6.6l2.767,2.773",
				transform: "translate(-15.2 -4.227)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13000",
				"data-name": "Path 13000",
				d: "M15.817,5.86,10.95,10.72",
				transform: "translate(-9.117 -3.98)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13001",
				"data-name": "Path 13001",
				d: "M3,17.45l2.433,2.433",
				transform: "translate(6.567 -7.843)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13002",
				"data-name": "Path 13002",
				d: "M8.353,12.35l-.973.973",
				transform: "translate(0.727 -6.143)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13003",
				"data-name": "Path 13003",
				d: "M10.543,10.16l-.973.973",
				transform: "translate(-2.923 -5.413)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13004",
				"data-name": "Path 13004",
				d: "M19.483,3.04,16.45,6.073",
				transform: "translate(-16.45 -3.04)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13005",
				"data-name": "Path 13005",
				d: "M5.287,10.27l4.358,4.358a1.333,1.333,0,0,0,1.885,0l1.071-1.07a1.333,1.333,0,0,0,0-1.885L8.244,7.315",
				transform: "translate(-2.517 -4.465)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_13006",
		"data-name": "Path 13006",
		d: "M16,0H0V16H16Z",
		fill: "none"
	})]
});
export default SvgMedicalExamYes;
